import { getCurrentInstance, hasInjectionContext } from 'vue'

/**
 * Structural slice of the Nuxt app that server-shared code is allowed to read.
 * Do not import `nuxt/app` or `#imports` from this file. Nitro bundles anything
 * `libs/middleware` reaches, and `nuxt/app` statically imports `#build/*`, which
 * Impound rejects in the server runtime.
 */
export interface AmbientNuxtApp {
  $pinia?: unknown
  $device?: {
    isMobile?: boolean
    isTablet?: boolean
    isDesktop?: boolean
    isMobileOrTablet?: boolean
  }
  ssrContext?: { event?: { context?: { traceId?: string } } }
  _refreshInFlight?: Promise<boolean>
}

/**
 * Read the current Nuxt app without calling `useNuxtApp()`.
 * Missing context returns undefined (no NUXT_E1001).
 */
export function readAmbientNuxtApp(): AmbientNuxtApp | undefined {
  if (hasInjectionContext()) {
    const app = getCurrentInstance()?.appContext.app as { $nuxt?: AmbientNuxtApp } | undefined
    if (app?.$nuxt) return app.$nuxt
  }

  const namespace = (globalThis as { __unctx__?: { get?: (key: string) => { tryUse?: () => unknown } | undefined } }).__unctx__
  const fromContext = namespace?.get?.('nuxt-app')?.tryUse?.()
  return (fromContext as AmbientNuxtApp | undefined) || undefined
}
